import { getOperationPackageInstance as getSharedOperationPackageInstance, postOperationPackageInstanceArchive } from '@/features/operation-instances/api';
export function getOperationPackageInstance(params: {
  instanceId: string;
}) {
  const {
    instanceId
  } = params;
  return getSharedOperationPackageInstance('IT_OPERATION_CORE', instanceId);
}
export function archiveInstance(params: {
  instanceId: string;
}) {
  const {
    instanceId
  } = params;
  return postOperationPackageInstanceArchive('IT_OPERATION_CORE', instanceId);
}